"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateVideo = exports.serializeVideo = void 0;
const serializeVideo = (item) => {
    return item.data.playedAtLeastOnce
        ? "Played at least once."
        : "Not played at least once.";
};
exports.serializeVideo = serializeVideo;
const validateVideo = (item) => {
    if (!item.required || item.data.playedAtLeastOnce) {
        return { valid: true };
    }
    return {
        valid: false,
        error: { message: "Video must be played at least once." },
    };
};
exports.validateVideo = validateVideo;
//# sourceMappingURL=video.js.map